<template>
    <div class="update-menu-container">
        <div class="update-menu-nav">
            <div class="menu-nav-title">
                <span>编辑文档菜单</span>
            </div>
            <div class="doc-nav-search">
                <a-input-search v-model="searchValue"
                                style="80%"
                                placeholder="输入关键字查询"
                                size="small"
                                @search="onInputSearch" />
                <a-icon type="plus-square"
                        @click="creatMenu"
                        class="createTitle" />
            </div>
            <div class="menu-nav-tree">
                <a-tree v-if="menuTreeData.length"
                        class="draggable-tree"
                        show-line
                        draggable
                        default-expand-all
                        :default-selected-keys="treeSelectedKeys"
                        :selectedKeys="treeSelectedKeys"
                        :tree-data="menuTreeData"
                        @dragend="dragMenu"
                        @drop="onDrop"
                        @rightClick="showMenu"
                        @select="onMenuTreeSelect" />
                <div v-else
                     class="create-menu"
                     @click="addSubMenuShow=true">
                    <a-icon type="plus-square" /> <span>创建菜单</span>
                </div>
            </div>
            <vue-context-menu :contextMenuData="contextMenuData"
                              @addSubMenu="addSubMenu"
                              @removeMenu="removeMenu"
                              @editMenu="editMenu"></vue-context-menu>
        </div>
        <a-modal v-model="addSubMenuShow"
                 :title="externalCreateMenu?'创建菜单':'创建子菜单'"
                 okText="保存"
                 cancelText="取消"
                 @cancel="cancel"
                 @ok="handleOk">
            <div class="operator-item-div">
                <a-form-model ref="createSubForm"
                              :model="createSubForm"
                              :rules="createSubRule"
                              :label-col="{span:4}"
                              :wrapper-col="{span:15}">
                    <a-form-model-item label="父菜单"
                                       v-if="!externalCreateMenu"
                                       class="marginbot20 margintop10">
                        <a-tree-select v-model="createSubForm.parentId"
                                       :getPopupContainer="(triggerNode)=>{return triggerNode.parentNode}"
                                       style="width: 100%"
                                       :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                       :tree-data="formTreeData"
                                       :disabled="currentSelectedTree.zIndex === '4'"
                                       placeholder="请选择">
                        </a-tree-select>
                    </a-form-model-item>
                    <a-form-model-item label="菜单名"
                                       class="marginbot20"
                                       prop="title">
                        <a-input v-model="createSubForm.title"
                                 :disabled="currentSelectedTree.zIndex ==='4'"
                                 :maxLength="32"
                                 placeholder="请输入菜单名称" />
                    </a-form-model-item>
                    <!-- <a-form-model-item label="菜单位置"
                                       class="marginbot20">
                        <a-select v-model="createSubForm.position"
                                  :getPopupContainer="(triggerNode)=>{return triggerNode.parentNode}"
                                  placeholder="菜单摆放位置">
                            <a-select-option v-for="item in positionList"
                                             :key="item.value"
                                             :value="item.value">
                                {{item.label}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item> -->
                </a-form-model>
            </div>
        </a-modal>
        <a-modal v-model="removeMenuShow"
                 title="删除菜单"
                 okText="确认"
                 cancelText="取消"
                 @ok="removeOk">
            <p>您确认要确认删除 <strong>{{editSubForm.title}}</strong> 菜单吗？</p>
        </a-modal>
        <a-modal v-model="editMenuShow"
                 title="编辑菜单"
                 okText="保存"
                 cancelText="取消"
                 @ok="editOk">
            <div class="operator-item-div">
                <a-form-model ref="editSubForm"
                              :model="editSubForm"
                              :rules="editSubRule"
                              :label-col="{span:4}"
                              :wrapper-col="{span:15}">
                    <a-form-model-item label="菜单名"
                                       class="marginbot20"
                                       prop="title">
                        <a-input v-model="editSubForm.title"
                                 :maxLength="32"
                                 placeholder="请输入菜单名称" />
                    </a-form-model-item>
                    <!-- <a-form-model-item label="菜单位置"
                                       class="marginbot20">
                        <a-select v-model="editSubForm.position"
                                  :getPopupContainer="(triggerNode)=>{return triggerNode.parentNode}"
                                  placeholder="菜单摆放位置">
                            <a-select-option v-for="item in positionList"
                                             :key="item.value"
                                             :value="item.value">
                                {{item.label}}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item> -->
                </a-form-model>
            </div>
        </a-modal>
    </div>
</template>

<script>
import qs from 'qs'
export default {
    name: 'updateMenuDrawer',
    data () {
        return {
            addSubMenuShow: false,
            removeMenuShow: false,
            editMenuShow: false,
            externalCreateMenu: false,
            top: 0,
            left: 0,
            dbData: [], // 当前菜单数据
            treeSelectedKeys: [], // 左侧菜单Tree选中keys
            menuTreeData: [], // 左侧菜单树
            currentSelectedTree: {}, // 当前选中key
            formTreeData: [], // 表单树形结构
            positionList: [
                {
                    label: '顶部',
                    value: 'top'
                },
                {
                    label: '左侧',
                    value: 'left'
                }
            ],
            createLoading: false,
            createSubForm: {
                parentId: undefined,
                title: '',
                position: 'left'
            },
            contextMenuData: {
                // the contextmenu name(@1.4.1 updated)
                menuName: 'demo',
                // The coordinates of the display(菜单显示的位置)
                axis: {
                    x: null,
                    y: null
                },
                // Menu options (菜单选项)
                menulists: [
                    {
                        fnHandler: 'editMenu',
                        icoName: '',
                        btnName: '编辑'
                    }, {
                        fnHandler: 'removeMenu',
                        icoName: '',
                        btnName: '删除'
                    }
                ]
            },
            createSubRule: {
                title: [
                    { required: true, message: '该字段不能为空', trigger: 'blur' }
                ]
            },
            editLoading: false,
            editSubForm: {
                title: '',
                position: 'left'
            },
            editSubRule: {
                title: [
                    { required: true, message: '该字段不能为空', trigger: 'blur' }
                ]
            },
            removeLoading: false,
            searchValue: '',
            draged: false,
            currentMenu: {} // 当前选中的菜单节点
        }
    },
    computed: {
        restUrl () {
            return this.$store.state.restUrl
        }
    },
    created () {
        // 初始化数据
        // this.initData()
    },
    methods: {
        creatMenu () {
            this.addSubMenuShow = true
            this.externalCreateMenu = true
        },
        addSubMenu () {
            this.addSubMenuShow = true
        },
        handleOk (e) {
            this.submit()
            this.$emit('updateMain')
            // 打开当前菜单
            this.addSubMenuShow = false
        },
        cancel () {
            this.addSubMenuShow = false
            this.externalCreateMenu = false
        },
        removeMenu () {
            this.removeMenuShow = true
        },
        removeOk () {
            this.removeMenuShow = false
            this.removeById()
        },
        editMenu () {
            this.editMenuShow = true
        },
        editOk () {
            this.save()
            this.editMenuShow = false
        },
        showMenu ({ event, node }) {
            event.preventDefault()
            this.onMenuTreeSelect([node.eventKey], { node })
            // 当前菜单为第4级菜单，无法创建子菜单
            if (this.currentSelectedTree.zIndex < 4) {
                if (!this.contextMenuData.menulists.find(item => item.btnName === '创建子菜单')) {
                    this.contextMenuData.menulists.unshift({
                        fnHandler: 'addSubMenu', // Binding events(绑定事件)
                        icoName: '', // icon (icon图标 )
                        btnName: '创建子菜单' // The name of the menu option (菜单名称)
                    })
                }
            } else {
                if (this.contextMenuData.menulists.find(item => item.btnName === '创建子菜单')) {
                    this.contextMenuData.menulists.shift()
                }
            }
            var x = event.clientX
            var y = event.clientY
            // Get the current location
            this.contextMenuData.axis = {
                x, y
            }
        },
        onInputSearch () {
            fetch(this.restUrl + '/search' + `?content=${this.searchValue}`).then(response => response.json()).then(result => {
                this.menuTreeData = this.parseDataSearch(result || [])
            })
        },
        parseDataSearch (data) {
            const cloneData = JSON.parse(JSON.stringify(data))
            const menu = []
            const map = {}
            cloneData.forEach(m => {
                m.children = []
                m.key = m.id
                m.value = m.id
                if (m.parentId === '0' || (!map[m.id] && !map[m.parentId])) {
                    menu.push(m) // 如果是根 就直接push到menu中
                } else {
                    map[m.parentId] && map[m.parentId].children.push(m)
                }
                map[m.id] = m // {1:菜单,2:菜单}
            })
            return menu
        },
        async initData (value) {
            this.currentMenu = value
            await fetch(this.restUrl + '/list', {
                headers: {
                    Connection: 'keep-alive'
                }
            }).then(response => response.json()).then(result => {
                this.dbData = result
                // 处理数据
                this.menuTreeData = this.parseData()
                // 父级菜单
                this.formTreeData = this.parseParentData()
                // 初始化创建菜单时的默认选中
                this.createSubForm.parentId = this.currentSelectedTree.id
            })
        },
        // 初始化tree数据
        parseData () {
            const cloneData = JSON.parse(JSON.stringify(this.dbData))
            return cloneData.filter((father, index) => {
                if (index === 0) {
                    // if (this.currentMenu) {
                    //     this.treeSelectedKeys = [this.currentMenu.id]
                    //     this.currentSelectedTree = this.currentMenu
                    //     this.editSubForm.title = this.currentMenu.title
                    //     this.editSubForm.position = this.currentMenu.position
                    // } else {
                    this.treeSelectedKeys = [father.id]
                    this.currentSelectedTree = father
                    this.editSubForm.title = father.title
                    this.editSubForm.position = father.position
                    // }
                }
                father.key = father.id
                father.value = father.id
                const branchArr = cloneData.filter(child => father.id === child.parentId)
                if (branchArr.length > 0) {
                    father.children = branchArr
                }
                return father.parentId === '0'
            })
        },
        // 初始化tree数据，去掉了3级数据
        parseParentData () {
            const cloneData = JSON.parse(JSON.stringify(this.dbData))
            return cloneData.filter((father) => {
                father.key = father.id
                father.value = father.id
                const branchArr = cloneData.filter(child => father.id === child.parentId && parseInt(child.zIndex) < 4)
                if (branchArr.length > 0) {
                    father.children = branchArr
                }
                return father.parentId === '0'
            })
        },
        // tree选中事件
        onMenuTreeSelect (selectedKeys, info, isTurnPage) {
            this.$emit('select', { key: isTurnPage ? selectedKeys[0] : info.node.value })
            this.treeSelectedKeys = selectedKeys
            const tableData = JSON.parse(JSON.stringify(this.dbData))
            for (let i = 0; i < tableData.length; i++) {
                const item = tableData[i]
                if (item.id === this.treeSelectedKeys[0]) {
                    this.currentSelectedTree = item
                    this.createSubForm.parentId = item.id
                    this.editSubForm.title = item.title
                    this.editSubForm.position = item.position
                    break
                }
            }
        },
        // 提交-创建子菜单
        submit () {
            this.$refs.createSubForm.validate(valid => {
                if (valid) {
                    const newObj = {
                        title: this.createSubForm.title,
                        parentId: this.createSubForm.parentId || '0',
                        position: this.createSubForm.position
                    }
                    if (this.externalCreateMenu) {
                        newObj.parentId = '0'
                    }
                    // 获取父级数据
                    if (newObj.parentId === '0') {
                        newObj.zIndex = 1
                    } else {
                        // 获取父级菜单zIndex属性，并加1
                        const tableData = JSON.parse(JSON.stringify(this.dbData))
                        for (let i = 0; i < tableData.length; i++) {
                            const item = tableData[i]
                            if (item.id === newObj.parentId) {
                                newObj.zIndex = parseInt(item.zIndex) + 1
                                break
                            }
                        }
                    }
                    // 创建
                    this.createLoading = true
                    fetch(this.restUrl + '/create', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: qs.stringify(newObj)
                    }).then(response => response.json()).then(result => {
                        if (result.status) {
                            setTimeout(() => {
                                this.createLoading = false
                                this.externalCreateMenu = false
                                this.initData()
                                this.resetCreateForm()
                                this.$emit('updateMain')
                            }, 500)
                        }
                    }).catch(err => {
                        console.error(err)
                    })
                }
            })
        },
        // 重置-创建子菜单
        resetCreateForm () {
            this.$refs.createSubForm.resetFields()
        },
        dragMenu (info) {
            this.draged = true
        },
        onDrop (info) {
            const dropKey = info.node.eventKey
            const dragKey = info.dragNode.eventKey
            const dropPos = info.node.pos.split('-')
            const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
            const loop = (data, key, callback) => {
                data.forEach((item, index, arr) => {
                    if (item.key === key) {
                        return callback(item, index, arr)
                    }
                    if (item.children) {
                        return loop(item.children, key, callback)
                    }
                })
            }
            const data = [...this.menuTreeData]

            // Find dragObject
            let dragObj
            loop(data, dragKey, (item, index, arr) => {
                arr.splice(index, 1)
                dragObj = item
            })
            if (!info.dropToGap) {
                // Drop on the content
                loop(data, dropKey, item => {
                    item.children = item.children || []
                    // where to insert 示例添加到尾部，可以是随意位置
                    item.children.push(dragObj)
                })
            } else if (
                (info.node.children || []).length > 0 && // Has children
                info.node.expanded && // Is expanded
                dropPosition === 1 // On the bottom gap
            ) {
                loop(data, dropKey, item => {
                    item.children = item.children || []
                    // where to insert 示例添加到尾部，可以是随意位置
                    item.children.unshift(dragObj)
                })
            } else {
                let ar
                let i
                loop(data, dropKey, (item, index, arr) => {
                    ar = arr
                    i = index
                })
                if (dropPosition === -1) {
                    ar.splice(i, 0, dragObj)
                } else {
                    ar.splice(i + 1, 0, dragObj)
                }
            }
            this.menuTreeData = data
        },
        // 保存-编辑菜单
        save () {
            this.$refs.editSubForm.validate(valid => {
                if (valid) {
                    this.editLoading = true
                    fetch(this.restUrl + '/update/' + this.currentSelectedTree.id, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: qs.stringify({ title: this.editSubForm.title, position: this.editSubForm.position })
                    }).then(response => response.json()).then(result => {
                        if (result.status) {
                            setTimeout(() => {
                                this.editLoading = false
                                this.initData()
                                this.resetEditForm()
                                this.$emit('updateMain')
                            }, 500)
                        }
                    }).catch(err => {
                        console.error(err)
                    })
                }
            })
        },
        // 重置-编辑菜单
        resetEditForm () {
            this.$refs.editSubForm.resetFields()
        },
        removeById () {
            this.removeLoading = true
            fetch(this.restUrl + '/remove/' + this.currentSelectedTree.id, {
                method: 'delete'
            }).then(response => response.json()).then(result => {
                if (result.status) {
                    // setTimeout(() => {
                    this.removeLoading = false
                    this.initData()
                    const key = this.currentSelectedTree.parentId
                    this.$emit('select', { key })
                    // }, 500)
                }
            })
        }
    }
}
</script>
<style lang="less">
.ant-tree.ant-tree-show-line li span.ant-tree-switcher {
    background: #f2f5fc;
}
// .ant-modal {
.ant-btn-primary {
    background-color: #c7000a !important;
    border-color: #c7000a !important;
}
// }
.context-menu-list {
    &:hover {
        background: #c7000a !important;
        color: #fff;
    }
}
</style>
<style lang="less" scoped>
.update-menu-container {
    width: 100%;
    height: 100%;
    display: flex;
    .create-menu {
        margin-left: 5px;
        cursor: pointer;
    }
    .contextmenu {
        margin: 0;
        background: #fff;
        z-index: 3000;
        position: absolute;
        list-style-type: none;
        padding: 5px 0;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: #333;
        box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
        li {
            margin: 0;
            padding: 7px 16px;
            cursor: pointer;
            &:hover {
                background: #eee;
            }
        }
    }
    .update-menu-nav {
        width: 250px;
        height: 100%;
        border-right: 1px solid #e9e9e9;
        overflow-y: auto;
        overflow: hidden;
        // background: #f2f5fc;
        /deep/ .vue-contextmenu-listWrapper {
            padding-left: 0;
        }
        /deep/ .nav-name-right {
            height: 32px;
            line-height: 30px;
        }
        /deep/ .btn-wrapper-simple {
            height: 32px;
            line-height: 30px;
        }
        .menu-nav-title {
            position: relative;
            width: 100%;
            height: 50px;
            font-size: 16px;
            color: #3d3f43;
            line-height: 50px;
            padding-left: 15px;
            border-bottom: 1px solid #e4e6f3;
            transition: all 0.3s;
            font-weight: 700;
            .menu-edit-icon {
                position: absolute;
                right: 15px;
                top: 18px;
                cursor: pointer;
                &:hover {
                    color: #0099d7;
                }
            }
        }
        .doc-nav-search {
            padding-top: 10px;
            /deep/ .ant-input-affix-wrapper {
                width: 90%;
                margin-right: 3px;
            }
            .createTitle {
                cursor: pointer;
            }
        }
        .menu-nav-tree {
            width: 100%;
            height: calc(~'100% - 84px');
            padding: 5px 10px;
            font-size: 14px;
            overflow: hidden;
            &:hover {
                overflow-y: auto;
            }
            /* // 自定义滚动条 */
            &::-webkit-scrollbar {
                width: 6px;
                max-height: 50px;
                border-radius: 50%;
                margin-right: 16px;
            }

            /* // 定义滚动条轨道 */
            &::-webkit-scrollbar-track {
                background-color: transparent !important;
                /* // display: none; */
            }

            /* // 内轨道部分 */
            &::-webkit-scrollbar-thumb {
                border-radius: 5px;
                background-color: #d7d7d7 !important;
            }

            &::-webkit-scrollbar-thumb:hover {
                cursor: pointer;
                /* background-color: #365466 !important; */
            }
        }
    }
    .update-menu-content {
        width: calc(~'100% - 250px');
        height: 100%;
        padding: 0 20px 20px 20px;
        .current-menu-item {
            width: 100%;
            height: 50px;
            line-height: 50px;
        }
        .content-operator-item {
            background: #f1f3f6;
            margin-top: 20px;
            width: 70%;
            .operator-item-title {
                width: 100%;
                height: 40px;
                font-size: 14px;
                font-weight: 600;
                padding-left: 20px;
                line-height: 40px;
                border-bottom: 1px solid #e9e9e9;
            }
            .operator-item-div {
                width: 100%;
                padding-bottom: 1px;
            }
        }
        .marginbot20 {
            margin-bottom: 20px;
        }
        .margintop10 {
            margin-top: 10px;
        }
    }
}
</style>
